import { ActionBase } from '../../../core/store/action/ActionBase';
import { ExtractModel } from "../../models/ExtractModel";

export const GET_SELECTED_EXTRACT_MODEL = '[Extract] Get Selected Extract Model';

export class GetSelectedExtractModelAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_SELECTED_EXTRACT_MODEL;

  constructor () {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GetSelectedExtractModelAction.ts